import { CollectionPricingHero } from "./collection-pricing-hero.tsx";

export const StrategyCollectionPricingHero = () => {
    return (
        <CollectionPricingHero
            collectionImage={{
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
                alt: "Strategy Collection"
            }}
            products={[
                {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/hd3m515u7j3s37rldpf0dgeb7m383j4s.svg",
                        alt: "Align"
                    }
                },
                {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg",
                        alt: "Talent"
                    }
                },
                {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/24e3l0ul76q4fpa4l2mmc7t00k202322.svg",
                        alt: "Focus"
                    }
                }
            ]}
        />
    );
};
